import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import '../styles/AdventureSection.css';

const AdventureSection = () => {
  const navigate = useNavigate();

  return (
    <section className="adv-section">
      <div className="adv-content">
        <h2 className="adv-title">Ready to Book Your Adventure?</h2>
        <p className="adv-description">
          Start planning your next unforgettable experience with us. Whether it’s a scenic cruise, an exotic island, or an urban adventure, we’re here to make it happen!
        </p>
        <motion.button
          className="adv-button"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate('/contact')}
        >
          Contact Us
        </motion.button>
      </div>
    </section>
  );
};

export default AdventureSection;
